import { c as _c } from "react/compiler-runtime";
import { cn } from "@local/utils/src/cn";
import { Link } from "../../ui/Link";
import type { Offer } from "@local/offer/src/types";
import { getCdnUrl } from "@local/utils/src/getCdnUrl";
import Image from "next/image";
export const SingleCategoryCard = t0 => {
  const $ = _c(23);
  const {
    category,
    className,
    market
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("group relative", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = `/${market}/category/${category.slug}`;
  const t3 = category.name || "category image";
  const t4 = category.media?.url || "/images/marble_bg.png";
  let t5;
  if ($[2] !== t4) {
    t5 = getCdnUrl({
      src: t4
    });
    $[2] = t4;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== t3 || $[5] !== t5) {
    t6 = <Image alt={t3} src={t5} quality={75} fill={true} sizes="(max-width: 640px) 50vw, (max-width: 1024px) 25vw, 230px" className="object-cover" />;
    $[4] = t3;
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t2 || $[8] !== t6) {
    t7 = <div className="aspect-[3/4] w-full overflow-hidden"><div className="relative h-full w-full transform bg-cover bg-top transition-all duration-300 ease-in-out group-hover:scale-105"><Link className="relative block h-full w-full" href={t2} prefetch={false}>{t6}</Link></div></div>;
    $[7] = t2;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== category.name || $[11] !== category.slug || $[12] !== market) {
    t8 = <h3 className="text-h5 leading-heading font-display mt-1 font-semibold uppercase">{category?.slug ? <Link href={`/${market}/category/${category.slug}`} prefetch={false} className={cn("relative block group-hover:underline")}><span className="absolute inset-0" />{category?.name}</Link> : <span className="relative block">{category?.name}</span>}</h3>;
    $[10] = category.name;
    $[11] = category.slug;
    $[12] = market;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  const t9 = `/${market}/category/${category.slug}`;
  let t10;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = cn("relative block group-hover:underline");
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <span>{">"}</span>;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== t9) {
    t12 = <div className="text-base font-semibold uppercase md:text-lg"><Link href={t9} prefetch={false} className={t10}>Explore Category {t11}</Link></div>;
    $[16] = t9;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== t1 || $[19] !== t12 || $[20] !== t7 || $[21] !== t8) {
    t13 = <div className={t1}>{t7}{t8}{t12}</div>;
    $[18] = t1;
    $[19] = t12;
    $[20] = t7;
    $[21] = t8;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  return t13;
};